import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-repeated-meetings",
  templateUrl: "./repeated-meetings.component.html",
})
export class RepeatedMeetingsComponent implements OnInit {
  exportRepeatedMeetingsList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;

  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  startDate: any;
  endDate: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  repeatedMeetingList: any = []; // Table Data list
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = "";

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: MentorshipDashboardService,
    private excelService: ExcelService
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  totalRepeatedMeetings: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;

  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    this.startDate = strtDate;
    this.endDate = endDate;
    this.getListing();
    this.repeatedMeetingsListing();
  }

  getListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          type: "repeated_meetings",
          export: false,
          start_date: this.startDate,
          end_date: this.endDate,
        };

        const requestPayload = {
          ...dataTablesParameters,
          ...data,
        };

        const encryptedData = this.enc_dec.encrypt(
          JSON.stringify(requestPayload)
        );

        this.http
          .post<DataTablesResponse>(
            "/api/metric-list",
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            this.repeatedMeetingList = resp["data"];
            this.totalRepeatedMeetings = resp["recordsFiltered"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },

      columns: [
        { data: "id" },
        { data: "organizer_name" },
        { data: "invitee_name" },
        { data: "meeting_title" },
        { data: "start_time" },
        { data: "end_time" },
      ],
    };
  }

  formatDateRange(startDateStr) {
    const startDate = new Date(startDateStr);
    const format = (date) => {
      const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };
    return `${format(startDate)}`;
  }

  repeatedMeetingsListing() {
    const data = {
      draw: 1,
      start: 0,
      length: 1,
      order: [
        {
          column: 0,
          dir: "asc",
        },
      ],
      search: {
        value: "",
        regex: false,
      },
      start_date: this.startDate,
      end_date: this.endDate,
      export: true,
      type: "repeated_meetings",
    };
    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
        this.exportRepeatedMeetingsList = res["data"];
        this.fieldsToIncludeExcel = [
          "organizer_name",
          "invitee_name",
          "meeting_title",
          "start_time",
          "end_time",
        ];

        this.exl = true;

        this.loadHide();
      });
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exportRepeatedMeetingsList,
      this.fieldsToIncludeExcel,
      "Repeated Meetings"
    );
  }

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#repeated_meetings").DataTable();
    table.ajax.reload(null, false);
    this.repeatedMeetingsListing();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    $("#repeated_meetings").on("page.dt", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  ngOnDestroy(): void {
    $("#repeated_meetings").off("page.dt");
    this.dtTrigger.unsubscribe();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onFilter(startDateInput?: string, endDateInput?: string) {
    const datePicker = $(this.datePicker.nativeElement);
    datePicker.attr("placeholder", "Select Date Range");

    let start: moment.Moment | null = null;
    let end: moment.Moment | null = null;

    if (startDateInput && endDateInput) {
      start = moment(startDateInput, "MM/DD/YYYY");
      end = moment(endDateInput, "MM/DD/YYYY");

      this.startDate = start.format("YYYY-MM-DD");
      this.endDate = end.format("YYYY-MM-DD");
    }

    datePicker.daterangepicker(
      {
        autoUpdateInput: !!start,
        showDropdowns: true,
        startDate: start || undefined,
        endDate: end || undefined,
        maxDate: moment(),
        locale: {
          format: "MM/DD/YYYY",
        },
      },
      (selectedStart, selectedEnd, label) => {
        this.startDate = selectedStart.format("YYYY-MM-DD");
        this.endDate = selectedEnd.format("YYYY-MM-DD");

        datePicker.val(
          selectedStart.format("MM/DD/YYYY") +
            " - " +
            selectedEnd.format("MM/DD/YYYY")
        );

        this.repeatedMeetingsListing();
        const table = $("#repeated_meetings").DataTable();
        table.ajax.reload(null, false);
        this.loadShow();
      }
    );

    if (start && end) {
      datePicker.val(
        start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY")
      );
    } else {
      datePicker.val("");
    }
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("endDate");
    const table = $("#repeated_meetings").DataTable();
    table.ajax.reload(null, false);
    this.repeatedMeetingsListing();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
}
